import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import AppNavbar from "../../../components/common/AppNavbar";

/* ══ Single AdSense Unit ══ */
const AdUnit = () => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {}
  }, []);
  return (
    <div className="ad-wrapper">
      <div className="ad-label">Advertisement</div>
      <ins
        className="adsbygoogle"
        style={{ display: "inline-block", width: "300px", height: "300px" }}
        data-ad-client="ca-pub-8585027130601823"
        data-ad-slot="7838136769"
      />
    </div>
  );
};

const BharatAbroadWeeklyNewsletter = () => {
  return (
    <>
      <Helmet>
        <script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8585027130601823"
          crossOrigin="anonymous"
        />
        <html lang="en" />
        <title>
          BharatAbroad Weekly Newsletter | Diaspora, Immigration, Sports &
          Business Updates – Bharat Abroad
        </title>
        <meta
          name="description"
          content="This week's BharatAbroad newsletter covers PM Modi's Europe visit, Indian diaspora leadership, US green card and H-1B updates, IPL 2026, Quantum Valley Andhra Pradesh, and travel trends for Indians abroad."
        />
        <meta
          name="keywords"
          content="BharatAbroad newsletter, Indian diaspora news, PM Modi Sweden Norway visit, Tushar Kumar UK mayor, H-1B visa 2026, green card backlog EB-2 EB-3, IPL 2026, Quantum Valley Andhra Pradesh, Schengen visa delay, Indian professionals abroad, NRI news weekly"
        />
        <meta name="author" content="Bharat Abroad Editorial" />
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        />
        <meta name="theme-color" content="#0f2027" />
        <link
          rel="canonical"
          href="https://www.bharatabroad.com/newsletter/weekly-may-2026"
        />
        <meta name="geo.region" content="IN" />
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="BharatAbroad Weekly Newsletter | Diaspora, Immigration, Sports & Business – May 2026"
        />
        <meta
          property="og:description"
          content="PM Modi's Nordic visit, Tushar Kumar UK's youngest mayor, H-1B & green card updates, IPL 2026, Quantum Valley AP — your weekly digest for Indians abroad."
        />
        <meta
          property="og:url"
          content="https://www.bharatabroad.com/newsletter/weekly-may-2026"
        />
        <meta property="og:site_name" content="Bharat Abroad" />
        <meta property="og:locale" content="en_IN" />
        <meta
          property="og:image"
          content="https://www.bharatabroad.com/images/newsletter/weekly-may-2026-og.jpg"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="article:published_time"
          content="2026-05-08T00:00:00+05:30"
        />
        <meta
          property="article:modified_time"
          content="2026-05-08T00:00:00+05:30"
        />
        <meta property="article:section" content="Newsletter" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@BharatAbroad" />
        <meta
          name="twitter:title"
          content="BharatAbroad Weekly Newsletter — May 2026"
        />
        <meta
          name="twitter:description"
          content="PM Modi Nordic visit, UK's youngest Indian mayor, H-1B changes, IPL 2026 updates, Quantum Valley AP, and travel trends for Indians abroad."
        />
        <meta
          name="twitter:image"
          content="https://www.bharatabroad.com/images/newsletter/weekly-may-2026-og.jpg"
        />
        <script type="application/ld+json">{`
          {
            "@context":"https://schema.org","@type":"Article",
            "headline":"BharatAbroad Weekly Newsletter — Diaspora, Immigration, Sports & Business Updates",
            "datePublished":"2026-05-08T00:00:00+05:30","dateModified":"2026-05-08T00:00:00+05:30",
            "author":{"@type":"Organization","name":"Bharat Abroad Editorial","url":"https://www.bharatabroad.com/about"},
            "publisher":{"@type":"Organization","name":"Bharat Abroad","url":"https://www.bharatabroad.com","logo":{"@type":"ImageObject","url":"https://www.bharatabroad.com/images/logo/bharatabroad-logo.png","width":200,"height":60}},
            "mainEntityOfPage":{"@type":"WebPage","@id":"https://www.bharatabroad.com/newsletter/weekly-may-2026"},
            "image":{"@type":"ImageObject","url":"https://www.bharatabroad.com/images/newsletter/weekly-may-2026-og.jpg","width":1200,"height":630},
            "inLanguage":"en-IN","articleSection":"Newsletter"
          }
        `}</script>
        <script type="application/ld+json">{`
          {
            "@context":"https://schema.org","@type":"BreadcrumbList",
            "itemListElement":[
              {"@type":"ListItem","position":1,"name":"Home","item":"https://www.bharatabroad.com"},
              {"@type":"ListItem","position":2,"name":"Newsletter","item":"https://www.bharatabroad.com/newsletter"},
              {"@type":"ListItem","position":3,"name":"Weekly Update May 2026","item":"https://www.bharatabroad.com/newsletter/weekly-may-2026"}
            ]
          }
        `}</script>
      </Helmet>

      <AppNavbar />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;0,900;1,700&family=Source+Serif+4:ital,wght@0,300;0,400;0,600;1,300;1,400&family=Barlow:wght@400;500;600&display=swap');

        /* ── Reset ── */
        .news-page * { box-sizing: border-box; }
        .news-page { background: #f7f5f0; font-family: 'Source Serif 4', serif; color: #1a1a1a; }

        /* ══════════════════
           HERO / BANNER
        ══════════════════ */
        .news-hero {
          background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
          color: #fff;
          padding: 52px 0 44px;
          border-bottom: 4px solid #c8a84b;
        }
        .news-hero-eyebrow {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: #c8a84b;
          margin-bottom: 14px;
        }
        .news-hero h1 {
          font-family: 'Playfair Display', serif;
          font-size: clamp(28px, 5vw, 52px);
          font-weight: 900;
          line-height: 1.1;
          color: #fff;
          margin-bottom: 16px;
          letter-spacing: -0.5px;
        }
        .news-hero-sub {
          font-family: 'Source Serif 4', serif;
          font-size: clamp(14px, 2vw, 17px);
          font-weight: 300;
          font-style: italic;
          color: rgba(255,255,255,0.7);
          max-width: 720px;
          line-height: 1.65;
        }
        .news-hero-meta {
          display: flex;
          align-items: center;
          gap: 20px;
          margin-top: 24px;
          padding-top: 20px;
          border-top: 1px solid rgba(255,255,255,0.12);
          flex-wrap: wrap;
        }
        .news-hero-meta span {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          color: rgba(255,255,255,0.45);
          letter-spacing: 0.05em;
          text-transform: uppercase;
        }
        .news-hero-meta .sep { color: rgba(255,255,255,0.15); }

        /* ══════════════════
           CATEGORY TABS
        ══════════════════ */
        .news-tabs {
          background: #fff;
          border-bottom: 1px solid #e0dbd0;
          position: sticky;
          top: 0;
          z-index: 100;
        }
        .news-tabs-inner {
          display: flex;
          gap: 0;
          overflow-x: auto;
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .news-tabs-inner::-webkit-scrollbar { display: none; }
        .news-tab {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: #666;
          padding: 14px 20px;
          white-space: nowrap;
          border-bottom: 3px solid transparent;
          cursor: default;
          transition: color 0.2s, border-color 0.2s;
        }
        .news-tab.active {
          color: #0f2027;
          border-bottom-color: #c8a84b;
        }

        /* ══════════════════
           MAIN LAYOUT
        ══════════════════ */
        .news-body { padding: 48px 0 72px; }
        .news-grid {
          display: grid;
          grid-template-columns: 1fr 300px;
          gap: 40px;
          align-items: start;
        }

        /* ══════════════════
           SECTION BLOCK
        ══════════════════ */
        .news-section { margin-bottom: 48px; }
        .news-section-head {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
          padding-bottom: 12px;
          border-bottom: 2px solid #1a1a1a;
        }
        .news-section-tag {
          font-family: 'Barlow', sans-serif;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: #fff;
          background: #0f2027;
          padding: 3px 10px;
          border-radius: 3px;
        }
        .news-section-tag.gold  { background: #c8a84b; color: #1a1a1a; }
        .news-section-tag.green { background: #1a5c38; }
        .news-section-tag.red   { background: #9b1b1b; }
        .news-section-tag.blue  { background: #1a3a6b; }
        .news-section-tag.teal  { background: #1a5c4a; }

        /* ══════════════════
           LEAD ARTICLE
        ══════════════════ */
        .lead-article { margin-bottom: 28px; }
        .lead-article h2 {
          font-family: 'Playfair Display', serif;
          font-size: clamp(20px, 3.5vw, 28px);
          font-weight: 800;
          color: #0f2027;
          line-height: 1.25;
          margin-bottom: 10px;
          letter-spacing: -0.3px;
        }
        .lead-article .deck {
          font-size: 16px;
          font-weight: 300;
          font-style: italic;
          color: #555;
          line-height: 1.7;
          margin-bottom: 14px;
          border-left: 3px solid #c8a84b;
          padding-left: 14px;
        }
        .article-body p {
          font-size: 15.5px;
          line-height: 1.85;
          color: #2a2a2a;
          margin-bottom: 14px;
          font-weight: 300;
        }

        /* ══════════════════
           NEWS BULLETS
        ══════════════════ */
        .news-bullets { margin: 0; padding: 0; list-style: none; }
        .news-bullets li {
          display: flex;
          gap: 12px;
          padding: 13px 0;
          border-bottom: 1px solid #e5e0d5;
          font-size: 15px;
          line-height: 1.7;
          color: #2a2a2a;
          font-weight: 300;
        }
        .news-bullets li:last-child { border-bottom: none; }
        .bullet-dash {
          font-family: 'Barlow', sans-serif;
          font-weight: 700;
          color: #c8a84b;
          font-size: 18px;
          line-height: 1.5;
          flex-shrink: 0;
        }

        /* ══════════════════
           HIGHLIGHT BOX
        ══════════════════ */
        .news-highlight {
          background: #0f2027;
          color: #fff;
          border-radius: 4px;
          padding: 22px 24px;
          margin: 20px 0;
        }
        .news-highlight-label {
          font-family: 'Barlow', sans-serif;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.15em;
          text-transform: uppercase;
          color: #c8a84b;
          margin-bottom: 10px;
        }
        .news-highlight p {
          font-family: 'Playfair Display', serif;
          font-size: 18px;
          font-style: italic;
          color: #fff;
          line-height: 1.65;
          margin: 0;
        }

        /* ══════════════════
           CRICKET SCORE BOX
        ══════════════════ */
        .cricket-box {
          border: 2px solid #1a1a1a;
          border-radius: 4px;
          overflow: hidden;
          margin: 16px 0;
        }
        .cricket-box-head {
          background: #1a1a1a;
          color: #fff;
          padding: 10px 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .cricket-box-title {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
        }
        .cricket-live {
          background: #c8a84b;
          color: #1a1a1a;
          font-family: 'Barlow', sans-serif;
          font-size: 9px;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          padding: 3px 8px;
          border-radius: 2px;
        }
        .cricket-box-body {
          background: #fff;
          padding: 16px;
        }
        .cricket-box-body p {
          font-size: 14.5px;
          color: #333;
          line-height: 1.7;
          margin: 0;
          font-weight: 300;
        }

        /* ══════════════════
           SIDEBAR
        ══════════════════ */
        .news-sidebar { position: sticky; top: 56px; }

        .sidebar-widget { margin-bottom: 32px; }
        .sidebar-widget-head {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #fff;
          background: #0f2027;
          padding: 6px 12px;
          margin-bottom: 14px;
          display: inline-block;
        }

        /* Quick facts */
        .quick-facts { list-style: none; padding: 0; margin: 0; }
        .quick-facts li {
          padding: 10px 0;
          border-bottom: 1px solid #e5e0d5;
          font-size: 13.5px;
          line-height: 1.6;
          color: #333;
          font-weight: 300;
          display: flex;
          gap: 8px;
          align-items: flex-start;
        }
        .quick-facts li:last-child { border-bottom: none; }
        .qf-bullet {
          width: 6px; height: 6px;
          border-radius: 50%;
          background: #c8a84b;
          flex-shrink: 0;
          margin-top: 6px;
        }

        /* Stat widget */
        .stat-widget {
          background: #fff;
          border: 1px solid #e0dbd0;
          border-radius: 4px;
          overflow: hidden;
        }
        .stat-widget-item {
          padding: 14px 16px;
          border-bottom: 1px solid #e0dbd0;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .stat-widget-item:last-child { border-bottom: none; }
        .stat-widget-label {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.06em;
          color: #888;
        }
        .stat-widget-val {
          font-family: 'Playfair Display', serif;
          font-size: 20px;
          font-weight: 700;
          color: #0f2027;
        }
        .stat-widget-delta {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 600;
          color: #1a5c38;
        }

        /* Ad wrapper */
        .ad-wrapper {
          background: #fff;
          border: 1px solid #e0dbd0;
          border-radius: 4px;
          padding: 16px;
          text-align: center;
        }
        .ad-label {
          font-family: 'Barlow', sans-serif;
          font-size: 9px;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #bbb;
          margin-bottom: 10px;
          font-weight: 600;
        }

        /* ══════════════════
           RESPONSIVE
        ══════════════════ */
        @media (max-width: 900px) {
          .news-grid { grid-template-columns: 1fr; }
          .news-sidebar { position: static; }
        }
        @media (max-width: 600px) {
          .news-hero { padding: 36px 0 32px; }
          .news-body { padding: 32px 0 56px; }
          .news-section { margin-bottom: 36px; }
        }
      `}</style>

      <div className="news-page">
        {/* ════════ HERO ════════ */}
        <div className="news-hero">
          <Container>
            <div className="news-hero-eyebrow">
              📰 BharatAbroad Weekly Newsletter · May 2026
            </div>
            <h1>BharatAbroad Weekly Newsletter</h1>
            <p className="news-hero-sub">
              Here is your quick and simple update on important news from Bharat
              and around the world. This week's focus includes diaspora updates,
              immigration news, sports, and business developments.
            </p>
            <div className="news-hero-meta">
              <span>🕐 5 min read</span>
              <span className="sep">·</span>
              <span>📅 May 19, 2026</span>
              <span className="sep">·</span>
              <span>✍️ Bharat Abroad Editorial</span>
            </div>
          </Container>
        </div>

        {/* ════════ CATEGORY TABS ════════ */}

        {/* ════════ BODY ════════ */}
        <div className="news-body">
          <Container>
            <div className="news-grid">
              {/* ══ MAIN COLUMN ══ */}
              <main>
                {/* ── Section 1: Diaspora ── */}
                <div className="news-section">
                  <div className="news-section-head">
                    <span className="news-section-tag gold">
                      🌏 International Relations &amp; Diaspora
                    </span>
                  </div>

                  <div className="lead-article">
                    <h2>
                      PM Modi's Nordic Visit Energises Bharat Diaspora
                      Communities
                    </h2>
                    <p className="deck">
                      Large turnouts at public events in Sweden and Norway
                      signal deepening ties between Bharat and Europe in
                      technology, clean energy, and innovation.
                    </p>
                    <div className="article-body">
                      <p>
                        Our Honorable Prime Minister's Narendra Modi Ji visits
                        to Sweden and Norway drew strong engagement from Bharat
                        diaspora communities, with large turnouts at public
                        events. Bharat continues to build strong relationships
                        with countries in Europe, especially in areas like
                        technology, clean energy, and innovation between Bharat
                        and Nordic countries. These partnerships are expected to
                        create more opportunities for Bharat professionals
                        worldwide.
                      </p>
                    </div>
                  </div>

                  <div className="news-highlight">
                    <div className="news-highlight-label">
                      🌍 Rising Global Representations by Bharat Nationals
                    </div>
                    <p>
                      Bharat origin people are taking on leadership roles in
                      different countries, showing the growing impact of the
                      Bharat community abroad. A 23‑year‑old Bharat leader,{" "}
                      <strong>Tushar Kumar</strong>, became one of the youngest
                      mayors in the UK, reflecting the growing role of the
                      Bharat diaspora in international civic leadership.
                    </p>
                  </div>
                </div>

                {/* ── Section 2: Immigration ── */}
                <div className="news-section">
                  <div className="news-section-head">
                    <span className="news-section-tag blue">
                      🛂 Immigration Updates
                    </span>
                  </div>

                  <div className="article-body">
                    <p>
                      Immigration remains a major concern for Indians living
                      abroad.
                    </p>
                  </div>

                  <ul className="news-bullets">
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        <strong>Green card wait times</strong> in the United
                        States are still very long for Bharat National
                        applicants. Applicants in EB‑2 and EB‑3 categories
                        continue to face long waiting periods with minimal
                        progress, with backlogs extending over a decade in many
                        cases.
                      </span>
                    </li>
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        <strong>H‑1B changes.</strong> The US continues
                        emphasizing higher-skilled and higher-wage immigration
                        pathways, potentially benefiting experienced
                        professionals but challenging early-career applicants.
                        Discussions around raising minimum wages for H‑1B visa
                        holders by ~30% could make hiring foreign workers
                        costlier but may increase salary benchmarks for Bharat
                        professionals abroad. Visa appointments are slowly
                        improving but are still limited.
                      </span>
                    </li>
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        <strong>Student visa reforms</strong> under discussion
                        and the possible changes to US student visas (e.g.,
                        shorter duration limits) may impact Indian students
                        planning long-term stays.
                      </span>
                    </li>
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        <strong>Schengen visa demand</strong> remains high,
                        causing appointment delays for Bharat National
                        travelers.
                      </span>
                    </li>
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        <strong>New Zealand's</strong> temporary shutdown of
                        online portals affected visa system updates and
                        applicants globally.
                      </span>
                    </li>
                  </ul>
                </div>

                {/* ── Section 3: Sports ── */}
                <div className="news-section">
                  <div className="news-section-head">
                    <span className="news-section-tag green">
                      🏏 Sports - Cricket
                    </span>
                  </div>

                  <div className="cricket-box">
                    <div className="cricket-box-head">
                      <span className="cricket-box-title">
                        IPL 2026 — Season Update
                      </span>
                      <span className="cricket-live">● Live Season</span>
                    </div>
                    <div className="cricket-box-body">
                      <p>
                        IPL 2026 action continues - The IPL 2026 season is
                        reaching its final stage, with RCB leading, a few teams
                        already close to qualification, and several others still
                        fighting hard for playoff spots.
                      </p>
                    </div>
                  </div>
                </div>

                {/* ── Section 4: Economy ── */}
                <div className="news-section">
                  <div className="news-section-head">
                    <span className="news-section-tag teal">
                      💼 Economy, Business &amp; Technology
                    </span>
                  </div>

                  <ul className="news-bullets">
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        Bharat is working closely with Nordic countries,
                        especially in areas like clean energy, technology, and
                        business investments.
                      </span>
                    </li>
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        Andhra Pradesh is developing a new project called{" "}
                        <strong>Quantum Valley</strong>, which is attracting
                        advanced technology companies and researchers from
                        around the world.
                      </span>
                    </li>
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        Many Indian cities are facing challenges like pollution
                        and fast growth, showing the need for cleaner and better
                        infrastructure.
                      </span>
                    </li>
                  </ul>
                </div>

                {/* ── Section 5: Travel ── */}
                <div className="news-section">
                  <div className="news-section-head">
                    <span className="news-section-tag red">
                      ✈️ Travel &amp; Mobility Trends
                    </span>
                  </div>

                  <ul className="news-bullets">
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        Rising jet fuel prices are continuing to put pressure on
                        the aviation sector, leading to higher airfares and
                        occasional travel disruptions, particularly on routes
                        frequently used by Bharat expatriates.
                      </span>
                    </li>
                    <li>
                      <span className="bullet-dash">—</span>
                      <span>
                        Several countries are updating their travel and visa
                        policies, making it important for travelers to plan
                        international trips well in advance to avoid delays or
                        unexpected challenges.
                      </span>
                    </li>
                  </ul>
                </div>
              </main>

              {/* ══ SIDEBAR ══ */}
              <aside className="news-sidebar">
                {/* Quick Facts widget */}
                <div className="sidebar-widget">
                  <div className="sidebar-widget-head">
                    This Week at a Glance
                  </div>
                  <ul className="quick-facts">
                    {[
                      "PM Modi visits Sweden & Norway",
                      "Tushar Kumar youngest UK mayor — age 23",
                      "EB-2 / EB-3 backlogs exceed a decade",
                      "H-1B wage hike discussions: ~30%",
                      "IPL 2026: RCB leads standings",
                      "Quantum Valley launches in Andhra Pradesh",
                      "Jet fuel prices push airfares higher",
                    ].map((fact) => (
                      <li key={fact}>
                        <span className="qf-bullet" />
                        <span>{fact}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Stat widget */}
                <div className="sidebar-widget">
                  <div className="sidebar-widget-head">Immigration Numbers</div>
                  <div className="stat-widget">
                    {[
                      { label: "EB-2 Backlog", val: "10+", delta: "Years" },
                      {
                        label: "H-1B Wage Hike",
                        val: "~30%",
                        delta: "Proposed",
                      },
                      { label: "Schengen Delay", val: "High", delta: "Demand" },
                    ].map((s) => (
                      <div className="stat-widget-item" key={s.label}>
                        <div>
                          <div className="stat-widget-label">{s.label}</div>
                          <div className="stat-widget-delta">{s.delta}</div>
                        </div>
                        <div className="stat-widget-val">{s.val}</div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* ── Single Ad Unit in sidebar ── */}
                <div className="sidebar-widget">
                  <AdUnit />
                </div>
              </aside>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
};

export default BharatAbroadWeeklyNewsletter;
